<div fxFlex="1 0 100%" fxLayout="column" fxLayoutAlign="start stretch">
   
    <div fxLayout fxLayout.lt-sm="column" fxLayoutAlign="end">
        <div fxFlex="2 1 0" *ngIf="gridConfig.isFilterable">
            <mat-form-field>
                <mat-label>Search Table</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
            </mat-form-field>
        </div>
        <div class="max-width-spacer" fxHide.lt-sm>
    <ng-container [ngTemplateOutlet]="actionTemplate"></ng-container>
        </div>
        <div>
            <mat-paginator class="no-wrap" *ngIf="gridConfig.IsPagingEnabled && !gridConfig.pagingInfo.serverSidePaging"
            [pageSizeOptions]="gridConfig.pagingInfo.pagingSizes" [pageSize]="gridConfig.pagingInfo.defaultpageSize"
            showFirstLastButtons></mat-paginator>
            <mat-paginator class="no-wrap" *ngIf="gridConfig.IsPagingEnabled && gridConfig.pagingInfo.serverSidePaging"
            [pageSizeOptions]="gridConfig.pagingInfo.pagingSizes" [pageSize]="gridConfig.pagingInfo.defaultpageSize"
           [length]="gridConfig.pagingInfo.pageLength" (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
        </div>
    </div>
    <div class="example-container mat-elevation-z8 m-12">
        <div class="table-container">
    <!-- <mat-card class="mat-card-container" [class.printcss]="gridConfig.removeScroll" id="gridmatcard"> -->
        <ng-container>
            <table mat-table [dataSource]="dataSource.data.length > 0 && dataSource.filteredData.length > 0 ? dataSource : emptyData" matSort (matSortChange)="onSortChange($event)" class="mat-elevation-z8"
            (contentChanged)="onContentChanged()">
            <ng-container *ngIf="gridConfig.isSelectable" matColumnDef="selectionRows" sticky>
                <th mat-header-cell *matHeaderCellDef class="select-column">
                    <mat-checkbox *ngIf="gridConfig.isMultiSelectable" color="primary"
                    (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllselected()"
                    [indeterminate]="selection.hasValue() && !isAllselected()"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="action-column">
                    <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"></mat-checkbox>
                </td>
            </ng-container>
            <ng-container *ngIf="gridConfig.primaryActions.length>0">
                <ng-container *ngFor="let action of gridConfig.primaryActions" [matColumnDef]="action?.name" sticky>
                    <th mat-header-cell *matHeaderCellDef [class.action-column-second]="gridConfig.isSelectable"
                     [class.action-column-first]="!gridConfig.isSelectable"></th>
                     <ng-container *matCellDef="let element">
                        <ng-container
                         *ngTemplateOutlet="actionDef && action.hasCustomTemplate ? actionDef.template : defaultPrimaryActionTemplate; context: {$implicit: {name: action?.name, value:element}}">
                        </ng-container>
                        <ng-template #defaultPrimaryActionTemplate>
                            <td mat-cell [id]="action.name" [class.action-column-second]="gridConfig.isSelectable"
                            [class.action-column-first]="!gridConfig.isSelectable">
                                <button mat-button (click)="onActionClick(action?.name,element)">
                                    <mat-icon [matTooltip]="action.tooltip" color="primary">{{action.icon_name}}</mat-icon>
                                </button>
                            </td>
                        </ng-template>
                     </ng-container>
                </ng-container>
            </ng-container>
    
            <ng-container *ngFor="let col of columns" >
            <ng-container *ngIf="col.stickyCol; else nonsticky">
                <ng-container [matColumnDef]="col.key" sticky>
                    <ng-container *ngIf="col.isSortable; else notSortable">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col.key" [title]="col.header"
                        [arrowPosition]="col.position=== fieldPosition.Right ? 'before' : 'after' ">
                        {{col.header}}
                    </th>
                    </ng-container>
                    <ng-template #notSortable>
                        <th mat-header-cell *matHeaderCellDef  [title]="col.header"
                        [class.text-right]="col.position == fieldPosition.Right">
                        {{col.header}}
                    </th>
                    </ng-template>
                    <ng-container *matCellDef="let element">
                        <ng-container
                        *ngTemplateOutlet="cellDef && col.hasCustomTemplate ? cellDef.template : defaultTemplate; context: {$implicit :{ column: col,value: element}}" >
                        </ng-container>
                        <ng-template #defaultTemplate>
                            <td mat-cell *ngIf="col.type == fieldType.Currency"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key | currency}}
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.Date"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key | date:'dd-MMM-yyyy'}}
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.Decimal"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key | number}}
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.Percent"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key | percent}}
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.isRedirect"
                            [class.text-right]="col.position == fieldPosition.Right">
                                <a mat-button color="primary" (click)="selectedRedirectColumn(element, col.key)" style="cursor: pointer;">{{element[col.key]}}</a>
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.input"
                            [class.text-right]="col.position == fieldPosition.Right">
                            <mat-form-field [style.width]="col.width">
                                <input matInput [id]="'txt-'+ col.key" [name]="col.key" [(ngModel)]="element[col.key]"
                                (ngModelChange)="isInputChange(element)" />
                            </mat-form-field>
                            </td>
                            <td mat-cell *ngIf="col.type === undefined || col.type === fieldType.String"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key }}
                            </td>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="gridConfig.hasFooter && col.footer">
                        <td mat-footer-cell *matFooterCellDef>
                            <ng-container *ngIf="col.footer.fieldType== fieldType.Currency"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value | currency}}
                            </ng-container>
                            <ng-container *ngIf="col.footer.fieldType== fieldType.Date"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value | date:'dd-MMM-yyyy'}}
                            </ng-container>
                            <ng-container *ngIf="col.footer.fieldType== fieldType.Decimal"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value | number}}
                            </ng-container>
                            <ng-container *ngIf="col.footer.fieldType== fieldType.Percent"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value | percent}}
                            </ng-container>
                            <ng-container *ngIf="col.footer.fieldType === undefined || col.footer.fieldType === fieldType.String"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value}}
                            </ng-container>
                        </td>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-template #nonsticky>
                <ng-container [matColumnDef]="col.key">
                    <ng-container *ngIf="col.isSortable; else notSortable">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col.key" [title]="col.header"
                        [arrowPosition]="col.position=== fieldPosition.Right ? 'before' : 'after' ">
                        {{col.header}}
                    </th>
                    </ng-container>
                    <ng-template #notSortable>
                        <th mat-header-cell *matHeaderCellDef  [title]="col.header"
                        [class.text-right]="col.position == fieldPosition.Right">
                        {{col.header}}
                    </th>
                    </ng-template>
                    <ng-container *matCellDef="let element">
                        <ng-container
                        *ngTemplateOutlet="cellDef && col.hasCustomTemplate ? cellDef.template : defaultTemplate; context: {$implicit :{ column: col,value: element}}" >
                        </ng-container>
                        <ng-template #defaultTemplate>
                            <td mat-cell *ngIf="col.type == fieldType.Currency"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key | currency}}
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.Date"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key | date:'dd-MMM-yyyy'}}
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.Decimal"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key | number}}
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.Percent"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key | percent}}
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.isRedirect"
                            [class.text-right]="col.position == fieldPosition.Right">
                                <a mat-button color="primary" (click)="selectedRedirectColumn(element, col.key)" style="cursor: pointer;">{{element[col.key]}}</a>
                            </td>
                            <td mat-cell *ngIf="col.type == fieldType.input"
                            [class.text-right]="col.position == fieldPosition.Right">
                            <mat-form-field [style.width]="col.width">
                                <input matInput [id]="'txt-'+ col.key" [name]="col.key" [(ngModel)]="element[col.key]"
                                (ngModelChange)="isInputChange(element)" />
                            </mat-form-field>
                            </td>
                            <td mat-cell *ngIf="col.type === undefined || col.type === fieldType.String"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{element | resolveProperty: col.key }}
                            </td>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="gridConfig.hasFooter && col.footer">
                        <td mat-footer-cell *matFooterCellDef>
                            <ng-container *ngIf="col.footer.fieldType== fieldType.Currency"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value | currency}}
                            </ng-container>
                            <ng-container *ngIf="col.footer.fieldType== fieldType.Date"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value | date:'dd-MMM-yyyy'}}
                            </ng-container>
                            <ng-container *ngIf="col.footer.fieldType== fieldType.Decimal"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value | number}}
                            </ng-container>
                            <ng-container *ngIf="col.footer.fieldType== fieldType.Percent"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value | percent}}
                            </ng-container>
                            <ng-container *ngIf="col.footer.fieldType === undefined || col.footer.fieldType === fieldType.String"
                            [class.text-right]="col.position == fieldPosition.Right">
                                {{col.footer.value}}
                            </ng-container>
                        </td>
                    </ng-container>
                </ng-container>
            </ng-template>

            </ng-container>
            
            <ng-container *ngIf="gridConfig.secondaryActions.length > 0">
                <ng-container *ngFor="let action of gridConfig.secondaryActions" [matColumnDef]="action?.name" sticky>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <ng-container *matCellDef="let element">
                    <ng-container 
                    *ngTemplateOutlet="actionDef && action.hasCustomTemplate ? actionDef.template : defaultActionTemplate; context : {$implicit: {value:element}}">
                    </ng-container>
                    <ng-template #defaultActionTemplate>
                        <td mat-cell [id]="action.name">
                            <button mat-button (click)="onActionClick(action.name,element)">
                                <mat-icon [matTooltip]="action.tooltip" color="primary">{{action.icon_name}}</mat-icon>
                            </button>
                        </td>
                    </ng-template>
                        
                    </ng-container>
                </ng-container>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: dataSource.data.length > 0 && dataSource.filteredData.length > 0 ? 
                displayColumns : ['empty-row'];"></tr>
            <ng-container *ngIf="gridConfig.hasFooter">
            <tr mat-footer-row *matFooterRowDef="displayColumns;"></tr>
            </ng-container>
            <ng-container matColumnDef="empty-row">
                <mat-cell *matCellDef="let element">No Data</mat-cell>
              </ng-container>
            </table>
        </ng-container>
    <!-- </mat-card> -->
    </div>
    </div>
    </div>
<!--     

    <ng-container *ngIf="col.isSortable; else notSortable">
        <ng-container *ngIf="col.stickyCol;else nonsticky" sticky>
            <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col.key" [title]="col.header"
            [arrowPosition]="col.position=== fieldPosition.Right ? 'before' : 'after' " 
            style="z-index: 102 !important;left: 72px !important;position: sticky;"
            >
            {{col.header}} s
        </th>
        </ng-container>
        <ng-template #nonsticky>
            <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col.key" [title]="col.header"
            [arrowPosition]="col.position=== fieldPosition.Right ? 'before' : 'after' ">
            {{col.header}} n
        </th>
        </ng-template>
    </ng-container>
    <ng-template #notSortable>
        <ng-container *ngIf="col.stickyCol;else nonsticky" sticky>
            <th mat-header-cell *matHeaderCellDef  [title]="col.header"
            [class.text-right]="col.position == fieldPosition.Right">
            {{col.header}} sn
        </th>
        </ng-container>
        <ng-template #nonsticky>
            <th mat-header-cell *matHeaderCellDef  [title]="col.header"
            [class.text-right]="col.position == fieldPosition.Right">
            {{col.header}} ns
        </th>
        </ng-template>
       
    </ng-template> -->